import { handleError } from "core/utils/HandleError"
import { handleResponse } from "core/utils/HandleResponse"
import { AuthHttpClient } from "core/utils/HttpClient"

export function getBrands(params?: any) {
  return AuthHttpClient
    .get('/stores/seagm/brand', { params })
    .then(handleResponse)
    .catch(handleError)
}

export function getBrandById(brandId: string | number) {
  return AuthHttpClient
    .get(`/stores/seagm/brand/${brandId}`)
    .then(handleResponse)
    .catch(handleError)
}

export function addBrand(data: any) {
  return AuthHttpClient
    .post('/stores/seagm/brand', data)
    .then(handleResponse)
    .catch(handleError)
}

export function updateBrand(data: any, brandId: string | number) {
  return AuthHttpClient
    .patch(`/stores/seagm/brand/${brandId}`, data)
    .then(handleResponse)
    .catch(handleError)
}

export function deleteBrand(brandId: string | number) {
  return AuthHttpClient
    .delete(`/stores/seagm/brand/${brandId}`)
    .then(handleResponse)
    .catch(handleError)
}
